module.exports = __webpack_public_path__ + "img/Award.52197004.jpg";